export default {"src":"/_next/static/media/check2.31d01f37.svg","height":34,"width":34};